'use client';

import { useQuery } from '@tanstack/react-query';

import { fetchPrV2ReviewThreads } from './fetch-pr-v2';
import { PR_V2_STANDARD_STALE_TIME_MS } from './query-config';
import { prV2ReviewThreadsQueryKey } from './query-keys';

export function usePrV2ReviewThreads(
  owner: string,
  repo: string,
  number: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: prV2ReviewThreadsQueryKey(owner, repo, number),
    queryFn: ({ signal }) => fetchPrV2ReviewThreads(owner, repo, number, signal),
    enabled: Boolean(owner && repo && number) && (options?.enabled ?? true),
    // Override the global previous-data placeholder so thread rows do not
    // briefly show the previous PR while the new query is fetching.
    placeholderData: () => undefined,
    staleTime: PR_V2_STANDARD_STALE_TIME_MS,
    refetchOnWindowFocus: false,
  });
}
